import Entity from "./Entity";
import common from "../common";
import DrawingSpine from "../drawing/DrawingSpine";
import DrawingTextureHack from "../drawing/DrawingTextureHack";
import paper from 'paper';
import {Emitter} from "pixi-particles";

export default class Rocket extends Entity {

    get emitterHolder() {
        return this._emitterHolder;
    }

    get view() {
        return this._view;
    }

    /*
    set view(value) {
        this._view = value;
        this._view.scale.set(0.25);
        this._view.autoUpdate = false;
        this._view.stateData.defaultMix = 0.2;
        //this._view.state.setAnimation(0, "guide", true);
        this._view.position.set(0, 0);
        this._view.visible = true;
        this.addChild(this._view);

        this._velocity = new P3.math.Vector2();
        this._view.rotation = this._velocity.angleBetween(new P3.math.Vector2(60, -60));
    }
     */

    get velocity() {
        return this._velocity;
    }

    constructor() {
        super();

        this.state = Rocket.STATES.START;

        this._chasis = new PIXI.Sprite(P3.assets.texture("chasis"));
        this._chasis.anchor.set(0.5);
        this._chasis.scale.set(0.6)
        this.addChild(this._chasis);

        const rocketKey = "rocket_" + P3.utils.padNum(common.rocketId, 2);

        this._emitterHolder = new PIXI.Container();
        this.addChild(this._emitterHolder);

        this._view = new DrawingSpine(P3.assets.spineData(rocketKey));
        this._view.scale.set(0.35);
        this._view.autoUpdate = false;
        this._view.stateData.defaultMix = 0.2;
        this.addChild(this._view);

        const hacks = common.saveData.getSpineHacks("rocket");

        for (let key in hacks) {
            //console.log(key);
            if (hacks.hasOwnProperty(key)) {
                const t = hacks[key];
                const path = new paper.CompoundPath();
                path.importJSON(t.path);

                const slot = this._view.skeleton.findSlot(key);
                const center = this.toLocal(slot.currentSprite.position, slot.currentSprite.parent);
                path.position.set(center.x + t.offset.x, center.y + t.offset.y);
                this._view.addTextureHack(DrawingTextureHack.create(path, slot, center));
            }


        }


        ///   this._velocity = new P3.math.Vector2();
        //   this._view.rotation = this._velocity.angleBetween(new P3.math.Vector2(60, -60));

        ///   this.angularVelocity = 0;

        ///  this.target = null;
        ///    this._steerStength = 2600;
        //     this._maxVelocity = 1400;

    }

    begin() {
        // this._velocity = new P3.math.Vector2(60, -60);
    }

    update(dt) {
        super.update(dt);
        this._view && this._view.update(dt);
       // this.launchEmitter.update(dt);
    }

    /*
        calculateVelocity(dt) {

            if (this.target) {
                const targetVelocity = this.target.subtract(new P3.math.Vector2(this.x, this.y));
                const steerForce = targetVelocity.normalize();
                this._velocity.x += steerForce.x * this._steerStength * dt;
                this._velocity.y += steerForce.y * this._steerStength * dt;

                // clamp velocity
                if (this._velocity.x > this._maxVelocity) {
                    this._velocity.x = this._maxVelocity;
                }
                if (this._velocity.x < -this._maxVelocity) {
                    this._velocity.x = -this._maxVelocity;
                }
                if (this._velocity.y > this._maxVelocity) {
                    this._velocity.y = this._maxVelocity;
                }
                if (this._velocity.y < -this._maxVelocity) {
                    this._velocity.y = -this._maxVelocity;
                }

                const angle = this.velocity.angleBetween(targetVelocity);
                this._view.rotation = angle - Math.PI;
            }

        }

        randomTarget() {
            // this.target = new P3.math.Vector2(common.STAGE_WIDTH * Math.random(), -common.STAGE_HEIGHT * Math.random() - 200);

            // P3.utils.delay(4 * Math.random() + 6, () => {
            // this.randomTarget();
            //});
        }

     */
}

Rocket.STATES = {};
Rocket.STATES.START = "start";
Rocket.STATES.UP = "up";
Rocket.STATES.DOWN = "down";
Rocket.STATES.LEFT = "left";
Rocket.STATES.RIGHT = "right";